import { useParams } from 'react-router';
import { Page } from '../../../ui/Page';
import { Breadcrumbs } from '../../../ui/PageHeader';
import { Section } from '../../../ui/Section';
import { ThreadView } from '../components/ThreadView';

/** Wątek wiadomości na osobnej stronie (`/poczta/:id`; link z Akceptacji, mobile). */
export function ThreadPage() {
  const { id = '' } = useParams();
  return (
    <Page width="reading">
      <Breadcrumbs items={[{ label: 'Poczta', to: '/poczta' }, { label: 'Wątek' }]} className="mb-4" />
      {/* wątek = jeden biały blok czytania (z tytułem), okruszki na tle */}
      <Section>
        <ThreadView threadId={id} headingLevel="h1" />
      </Section>
    </Page>
  );
}
